@if (hasProducts()) {
  <bx-card>
    <bx-card-header [title]="'property-details.product-status.title' | translate"></bx-card-header>

    <div class="grid w-full grid-cols-5">
      <hr class="bxi-table-separator-secondary mx-3xl mt-md" />

      @for (entry of columns(); track entry.product) {
        <div class="gap-md px-3xl pb-3xl pt-lg border-border-secondary flex flex-col" [class.border-l]="!$first">
          <div class="gap-md flex items-center justify-between">
            <span class="text-text-secondary-700 text-sm font-medium" [title]="translateName(entry.product)">
              {{ translateAbbreviation(entry.product) }}
            </span>
            <bxi-product-status-badge [severity]="entry.status?.severity" [iconOnly]="true"></bxi-product-status-badge>
          </div>

          @if (entry.status; as status) {
            <div class="flex flex-col">
              <span class="text-text-primary-900 text-2xl font-semibold">{{ status.devicesInError }}</span>
              <span class="text-text-tertiary-600 text-xs">
                {{ 'property-details.product-status.errorOf' | translate: { total: status.devices } }}
              </span>
            </div>
          }
        </div>
      }
    </div>
  </bx-card>
}
